<template>
  <main class="api-main">
    <div>
      <h1 v-if="!isMobile" class="api-main__title">
        {{ $route.meta.title }}
      </h1>
      <div class="api-main__content">
        <div class="api-main__container">
          <slot />
          <ApiDocsNav
            :prevRoute="$route.meta.prevRoute"
            :nextRoute="$route.meta.nextRoute"
            class="api-main__nav"
          />
        </div>
        <h1 v-if="isMobile" class="api-main__title">
          {{ $route.meta.title }}
        </h1>
        <ApiDocsAnchors />
      </div>
    </div>
  </main>
</template>

<script lang="ts" src="./ApiDocsMain.ts"></script>

<style scoped lang="scss" src="./ApiDocsMain.scss"></style>
